/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import * as $ from 'jquery';
import 'rxjs/add/operator/retry';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopBrandsService } from '../../../services/Home/top-brands.service';
import { SubscribeService } from './../../../services/subscribe/subscribe.service';
import { FormControl, FormGroup, FormBuilder, Validators, } from '@angular/forms';

@Component({
  selector: 'martmax-top-brands',
  templateUrl: './top-brands.component.html',
  styleUrls: ['./top-brands.component.css'],
  providers: [TopBrandsService, SubscribeService],
})
export class TopBrandsComponent {

  config: SwiperOptions = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    slidesPerView: 4,
    spaceBetween: 30
  };

  public errors: any;
  public topBrands: any;
  public subscribeErrors: any;
  public subscribeRespose: any;
  public subscribeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public route: ActivatedRoute,
    public subscribeService: SubscribeService,
    public topBrandsService: TopBrandsService,
  ) {
  }

  public ngOnInit() {
    this.createSubscribeForm();
    this.topBrandsService.getTopBrands().subscribe(
      (data) => {
          this.topBrands = data.topBrands
      },
      (errors) => {
        this.errors = errors;
      }
    );
  }

  public createSubscribeForm() {
    this.subscribeForm = this.fb.group({
      email: ['', [Validators.required]],
      gender: ['', []],
    });
  }

  /**
   * 
   * newsletter service 
   * 
   * @param email 
   * @param gender 
   */
  public subscribe(email: string, gender: string) {
    this.errors, this.subscribeErrors = null;
    
    this.subscribeService.store({
      email, gender,
    }).subscribe(
      (data) => {
        $('subscribe-form').hide(500);
        this.subscribeRespose = data[0];
      }, (subscribeErrors) => {
        this.subscribeErrors = subscribeErrors.email[0];
      });
  }

  public store(gender: string) {
    this.subscribe(this.subscribeForm.value.email, gender);
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/top-brands/top-brands.component.ts